import React from "react";
import About from "../About";
import Contact from "../Contact";
import Hero from "../Hero";
import Project from "../Project";
import Skills from "../Skills";

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Project />
      <Skills />
      <Contact />
    </div>
  );
};

export default Home;
